import React from 'react'
import './Buttons.css'

const BtnPrimary = (props) => (
  <button
    className='btn btn--primary'
    onClick={props.onClick}
    type={props.type || 'button'}
    disabled={props.disabled}>
    {props.children}
  </button>
)

const BtnSecondary = (props) => (
  <button
    className='btn btn--secondary'
    onClick={props.onClick}
    type={props.type || 'button'}
    disabled={props.disabled}>
    {props.children}
  </button>
)

const BtnDanger = (props) => (
  <button
    className='btn btn--danger'
    onClick={props.onClick}
    type={props.type || 'button'}
    disabled={props.disabled}>
    {props.children}
  </button>
)

export { BtnPrimary, BtnSecondary, BtnDanger }
